import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';

import { useRedirectPqrForm } from '../hook';
import { RedirectParamsData } from './data';
import { RedirectParamsHistorical } from '../historical';
import { RedirectRegisterHistory } from './registerHistory';

import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    REDIRECTEDIT,
    REDIRECTNEW,
    REDIRECTLIST,
} from '../../../../../routes/paths';

export const RedirectPqrDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const { redirect, setormikRedirectData, redirectHistorical } =
        useRedirectPqrForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = redirect && redirect?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle persona redirección PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={redirect?.id || ''}
                        buttonCreate={{
                            show: showActionButtons && !isOnlyViewProfile(type),
                            route: REDIRECTNEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: REDIRECTLIST,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: REDIRECTEDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <RedirectParamsHistorical
                            historical={redirectHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Interno"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <RedirectParamsData
                        data={redirect}
                        onChangeFormik={(formik) =>
                            setormikRedirectData(formik)
                        }
                    />
                </LayoutModule>
            </LayoutModule>
            <RedirectRegisterHistory redirect={redirect} />
        </>
    );
};
